import { dataHooks } from '@wix/data-hooks';

export const orderTrackingPageDataHooks = dataHooks<{
  title: {};
  orderNumber: {};
  statusLabel: {};
  statusTitle: {};
  statusDescription: {};
  detailsTitle: {};
  deliveryAddress: {};
  deliveryTime: {};
  error: {};
}>('order-tracking');
